<spinner *ngIf="loading"></spinner>

    <patient-registration-care-programme-block
        #patientBlock
        [carePrograms]="patientCarePrograms"
        [title]="'Patient - Care Programme'"
        [disabled]="disabled"
        *ngIf="['Patient', 'Patient and carer'].includes(typeOfUser)"
    >
    </patient-registration-care-programme-block>

    &nbsp;

    <patient-registration-care-programme-block
        #carerBlock
        [carePrograms]="carerCarePrograms"
        [title]="'Carer - Care Programme'"
        [disabled]="disabled"
        [childEnabled]="typeOfUser === 'Carer'"
        [patient]="patient"
        *ngIf="['Carer', 'Patient and carer'].includes(typeOfUser)"
    >
    </patient-registration-care-programme-block>

